function pickTranslation(translations, locale) {
  if (!translations || typeof translations !== "object") {
    return "";
  }

  if (translations[locale]) {
    return translations[locale];
  }

  const base = String(locale || "").split("-")[0];
  const matchedKey = Object.keys(translations).find(
    (key) => key === base || key.startsWith(`${base}-`) || key.startsWith(base),
  );

  if (matchedKey) {
    return translations[matchedKey];
  }

  return Object.values(translations).find(Boolean) ?? "";
}

function resolveShowText(value, locale) {
  if (typeof value === "boolean") return value;
  if (value === 0 || value === "0") return false;
  if (value === 1 || value === "1") return true;
  if (value && typeof value === "object") {
    const localeValue = value[locale];
    if (localeValue === undefined || localeValue === null) {
      const base = String(locale || "").split("-")[0];
      const matchedKey = Object.keys(value).find(
        (key) => key === base || key.startsWith(`${base}-`) || key.startsWith(base),
      );
      if (matchedKey === undefined) return true;
      return value[matchedKey] === true || value[matchedKey] === 1 || value[matchedKey] === "1";
    }
    return localeValue === true || localeValue === 1 || localeValue === "1";
  }
  return true;
}

export function mapUserSlidesToPortalRewards(slides, locale) {
  if (!Array.isArray(slides) || slides.length === 0) {
    return [];
  }

  return slides
    .map((slide, index) => {
      const imageSrc = pickTranslation(slide.poster, locale);
      const title = pickTranslation(slide.title, locale);
      const description = pickTranslation(slide.description, locale);
      const pointsLabel = pickTranslation(slide.extra_text, locale);

      return {
        id: slide.id ?? slide.plainId ?? `slide-${index}`,
        image: imageSrc ? "api" : "placeholder",
        imageSrc,
        useHero: false,
        theme: index % 2 === 0 ? "race" : "voucher",
        title,
        description,
        pointsLabel,
        linkUrl: pickTranslation(slide.link_url, locale) || null,
        newTab: Boolean(slide.new_tab),
        showText: resolveShowText(slide.show_text, locale),
      };
    })
    .filter((slide) => slide.title || slide.imageSrc);
}
